import Interceptor from "./Interceptor";

/**
 * Get all users (Admin only)
 */
export const getAllUsers = async (params = {}) => {
  try {
    const {
      page = 1,
      limit = 10,
      search = "",
      role,
      status,
      sortBy,
      sortOrder,
    } = params;

    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search }),
      ...(role && { role }),
      ...(status && { status }),
      ...(sortBy && { sortBy }),
      ...(sortOrder && { sortOrder }),
    });

    const response = await Interceptor.get(`/users?${queryParams}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get user by ID
 */
export const getUserById = async (userId) => {
  try {
    const response = await Interceptor.get(`/users/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Create new user (Admin only)
 */
export const createUser = async (userData) => {
  try {
    const response = await Interceptor.post("/users", userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update user
 */
export const updateUserData = async (userId, userData) => {
  try {
    const response = await Interceptor.put(`/users/${userId}`, userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Delete user (Admin only)
 */
export const deleteUser = async (userId) => {
  try {
    const response = await Interceptor.delete(`/users/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get user statistics (Admin only)
 */
export const getUserStats = async () => {
  try {
    const response = await Interceptor.get("/users/stats/overview");
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Toggle user status (activate/deactivate)
 */
export const toggleUserStatus = async (userId, isActive) => {
  try {
    const response = await Interceptor.put(`/users/${userId}`, { isActive });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update user role (Super Admin only)
 */
export const updateUserRole = async (userId, role) => {
  try {
    const response = await Interceptor.put(`/users/${userId}`, { role });
    return response.data;
  } catch (error) {
    throw error;
  }
};
